import React, { useState } from 'react';
import HeadingSection from 'components/LandingPageHeadingSection/HeadingSection';
import WinnipegModal from 'components/LandingPageModal/WinnipegModal';
import Link from 'next/link';
import Styles from './styles.js';
const RoomTypesTwo = props => {
  const [show, setShow] = useState('none');
  const [openPremiumModal, setOpenPremiumModal] = useState(false);
  const [openSupremModal, setOpenSupremModal] = useState(false);
  const [openAccessableModal, setOpenAccessableModal] = useState(false);
  const [premium, setPremium] = useState(false);
  const [supreme, setSupreme] = useState(false);
  const [accessable, setAccessable] = useState(false);
  const data = props;
  const dataModal = {
    roomSliderPremium: [
      {
        src: '/static/images/landingPages/s1.png',
      },
    ],
    roomSliderSupreme: [
      {
        src: '/static/images/landingPages/SingleSupreme.png',
      },
    ],
    roomSliderAccessable: [
      {
        src: '/static/images/landingPages/s2.png',
      },
    ],
  };
  return (
    <div>
      {' '}
      <div>
        <div className="">
          <div className="   text-white" style={{ backgroundColor: 'rgb(22, 22, 22)' }}>
            {premium ? (
              <div style={{ display: show }}>
                <WinnipegModal
                  dataModal={dataModal.roomSliderPremium}
                  show={openPremiumModal}
                  setClose={setOpenPremiumModal}
                />
              </div>
            ) : null}

            {/* SUPREME  */}

            {supreme ? (
              <div style={{ display: show }}>
                <WinnipegModal
                  dataModal={dataModal.roomSliderSupreme}
                  show={openSupremModal}
                  setClose={setOpenSupremModal}
                />
              </div>
            ) : null}

            {/* ACCESSIBLE  */}

            {accessable ? (
              <div style={{ display: show }}>
                <WinnipegModal
                  dataModal={dataModal.roomSliderAccessable}
                  show={openAccessableModal}
                  setClose={setOpenAccessableModal}
                />
              </div>
            ) : null}
            <HeadingSection title={data.title} heading={data.heading} bgcolor={data.bgcolor} subHd={data.subHd} />
            <div className="lg:container mx-auto px-6 lg:px-0 xxl:px-5  pt-4 mt-1">

              <div className="grid md:grid-cols-2 lg:grid-cols-3 grid-cols-1 gap-x-12 lg:px-0  xl:px-0 2xl:px-0  md:pt-8 pt-5  gap-x-5">
                <div className="  px-mobile-explore ">
                  <div className="card bg-transparent border-0   mb:pb-0  pb-4 ">
                    <div
                      onClick={() => {
                        setShow('flex');
                        setPremium(true);
                        setOpenPremiumModal(true);
                      }}>
                      <img
                        loading="lazy"
                        src={data.img}
                        className=" img w-full rounded-0 card-img-top px-mobile-explore-img"
                        alt="..."
                        style={{ cursor: 'pointer' }}
                      />
                    </div>
                    <div className="card-body p-0 pb-5">
                      <div
                        onClick={() => {
                          setShow('flex');
                          setPremium(true);
                          setOpenPremiumModal(true);
                        }}>
                        <div
                          onClick={() => {
                            setShow(' flex');
                            setPremium(true);
                            setOpenPremiumModal(true);
                          }}
                          className="card-title flex lg:flex-row flex-col
                           justify-between mt-4 mb-0 md:mb-3 pb-0 md:pb-3 pt-2"
                          style={{ fontFamily: 'josefin Sans', color: '#F7F7F7', cursor: 'pointer' }}>
                          <div>
                            <h5 className="fs-res-24">{data.titleOne}</h5>
                          </div>

                          <div className="flex md:flex-col flex-row">
                            <h5 className="fs-res-18 ps-1 md:ps-0">{data.price}</h5>
                          </div>
                        </div>
                      </div>
                      <p
                        className="card-text  fs-res-24-18 md:pb-4"
                        style={{ fontFamily: 'josefin Sans', color: '#a4a4a4' }}>
                        <p className="my-1">{data.p1}</p>
                        <p className="my-1">{data.p2}</p>
                        <p className="my-1">{data.p3}</p>
                      </p>
                    </div>
                  </div>
                </div>
                <div className=" px-mobile-explore">
                  <div className="card bg-transparent border-0    md:pb-0  pb-4 ">
                    <div
                      onClick={() => {
                        setShow(' flex');
                        setSupreme(true);
                        setOpenSupremModal(true);
                      }}>
                      <img
                        loading="lazy"
                        src={data.regularImg}
                        className=" img w-full rounded-0 card-img-top px-mobile-explore-img"
                        style={{ cursor: 'pointer' }}
                        alt="..."
                      />
                    </div>
                    <div className="card-body p-0 pb-5">
                      <div
                        onClick={() => {
                          setShow(' flex');
                          setSupreme(true);
                          setOpenSupremModal(true);
                        }}
                        className="card-title flex lg:flex-row flex-col
                           justify-between mt-4 mb-0 md:mb-3 pb-0 md:pb-3 pt-2"
                        style={{ fontFamily: 'josefin Sans', color: '#F7F7F7', cursor: 'pointer' }}>
                        <div>
                          <h5 className="fs-res-24">{data.titleTwo}</h5>
                        </div>

                        <div className="flex md:flex-col flex-row">
                          <h5 className="fs-res-18 pl-1 md:pl-0">{data.regularPrice}</h5>
                        </div>
                      </div>

                      <p
                        className="card-text fs-res-24-18 md:pb-4"
                        style={{ fontFamily: 'josefin Sans', color: '#a4a4a4' }}>
                        <p className="my-1">{data.regularP1}</p>
                        <p className="my-1">{data.regularP2}</p>
                        <p className="my-1">{data.regularP3}</p>
                      </p>
                    </div>
                  </div>
                </div>
                <div className=" px-mobile-explore ">
                  <div className="card bg-transparent border-0    pb-md-0  pb-4 ">
                    <div
                      onClick={() => {
                        setShow(' flex');
                        setAccessable(true);
                        setOpenAccessableModal(true);
                      }}>
                      <img
                        loading="lazy"
                        src={data.enSuitImg}
                        className=" img w-full rounded-0 card-img-top px-mobile-explore-img"
                        style={{ cursor: 'pointer' }}
                        alt="..."
                      />
                    </div>
                    <div className="card-body p-0 pb-5">
                      <div
                        onClick={() => {
                          setShow(' flex');
                          setAccessable(true);
                          setOpenAccessableModal(true);
                        }}
                        className="card-title flex lg:flex-row flex-col
                           justify-between mt-4 mb-0 mb-md-3 pb-0 md:pb-3 pt-2"
                        style={{ fontFamily: 'josefin Sans', color: '#F7F7F7', cursor: 'pointer' }}>
                        <div>
                          <h5 className="fs-res-24">{data.titleThree}</h5>
                        </div>

                        <div className="flex md:flex-col flex-row">
                          <h5 className="fs-res-18 ps-1 md:ps-0">{data.enSuitPrice}</h5>
                        </div>
                      </div>

                      <p
                        className="card-text fs-res-24-18 md:pb-4"
                        style={{ fontFamily: 'josefin Sans', color: '#a4a4a4' }}>
                        <p className="my-1">{data.enSuitP1}</p>
                        <p className="my-1">{data.enSuitP2}</p>
                        <p className="my-1">{data.enSuitP3}</p>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="text-center pb-3">
                {data.href ? (
                  <Link href={data.href}>
                    <button
                      type="button"
                      style={{
                        fontFamily: 'Josefin Sans',
                        color: '#010101',
                        backgroundColor: '#FCBD00',

                        fontWeight: '600',
                        paddingTop: '11px',
                        paddingBottom: '11px',
                        paddingLeft: '32px',
                        paddingRight: '32px',
                      }}
                      className="btn rounded-0   fs-16-18 mb-4 ">
                      {data.btnTxt}
                    </button>
                  </Link>
                ) : (
                  <a href={data.hrefExt} target="_blank" rel="noreferrer">
                    <button
                      type="button"
                      style={{
                        fontFamily: 'Josefin Sans',
                        color: '#010101',
                        backgroundColor: '#FCBD00',

                        fontWeight: '600',
                        paddingTop: '11px',
                        paddingBottom: '11px',
                        paddingLeft: '32px',
                        paddingRight: '32px',
                      }}
                      className="btn rounded-0   fs-16-18 mb-4 ">
                      {data.btnTxt}
                    </button>
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Styles />
    </div>
  );
};

export default RoomTypesTwo;
